<template>
    <el-dialog
        title="供应商评分表"
        class="key-data-trans-legal-dialog"
        :append-to-body="true"
        :visible.sync="visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="!confirmLoading && !pdfTransforming"
        ref="dialogRef"
        width="98%"
        top="3vh"
        :before-close="close"
    >
        <div v-loading="loading" class="content-wrap" ref="contentRef">
            <div class="title-container">
                <span class="title">供应商基础信息</span>
            </div>
            <BaseInfo ref="biRef" :pdfTransforming="pdfTransforming" type="lessThan" />
            <div class="title-container">
                <span class="title">资质信息</span>
            </div>
            <el-table :data="qlfTableData" :span-method="arraySpanMethod" border header-row-class-name="header-bg" class="margin-bottom-20">
                <el-table-column prop="businessType" label="业务类型" width="120"></el-table-column>
                <el-table-column prop="propertyNature" label="主体性质" width="120"></el-table-column>
                <el-table-column prop="zzlx" label="资质类型"></el-table-column>
                <el-table-column prop="qualificationFlag" label="是否符合" width="180">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>是否符合</span>
                    </template>
                    <template slot-scope="scope">
                        <el-radio v-model="scope.row.qualificationFlag" label="符合">符合</el-radio>
                        <el-radio v-model="scope.row.qualificationFlag" label="不符合">不符合</el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="sm" label="说明"></el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="title-container">
                <span class="title">能力评估</span>
                <div class="sub-title">1、运营能力</div>
            </div>
            <el-table :data="operationTableData" :span-method="opArraySpanMethod" border header-row-class-name="header-bg">
                <el-table-column prop="pgwd" label="评估维度" width="400"></el-table-column>
                <el-table-column prop="pfbz" label="评分标准">
                    <template slot-scope="scope">
                        <div style="white-space: pre-wrap;">{{ scope.row.pfbz }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="zf" label="总分" width="100"></el-table-column>
                <el-table-column prop="df" label="得分" width="100">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>得分</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input :class="scoreError(scope.row.df, scope.row.zf) ? 'is-error' : ''" v-model.trim="scope.row.df" placeholder="输入分数"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            
            <div class="require-title">评审要求</div>
            <div class="require-rule margin-bottom-20">1、评审规则：资质信息任一项不符合不得引入；运营能力总得分低于该项总分60%不得引入。</div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button :disabled="confirmLoading || pdfTransforming" @click="close">取 消</el-button>
            <el-button type="primary" :loading="confirmLoading || pdfTransforming" @click="confirm">确认提交</el-button>
            <!-- <el-button @click="generateAndUploadPDF('供应商评分表-运输【法人】.pdf')">生成PDF并上传</el-button> -->
        </span>
    </el-dialog>
</template>
<script>
import Decimal from 'decimal.js'
import BaseInfo from './BaseInfo.vue'
import scoreMixin from './scoreMixin.js';
import { onlineDetail, onlineSave } from '../../../../../../api/qualification.js';

// SRM_BASIC_QUALITY 供应商评分表-运输-零担专线
const TYPE = '39'

const INIT_QT = [
    { businessType: '运输', propertyNature: '法人', zzlx: '有与安得合作零担专线意愿', qualificationFlag: '', sm: '原则上此项中任何一条不符合不得引入。有特殊需求需走供应商特批引入。', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '安得所有零担业务必须使用蓝桥/车满满系统，确保零担在途节点可视', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '两个法人主体：经营主体和运营主体', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '拥有专线直营线路', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '证照齐全：营业执照/法人身份证/道路经营许可证', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '提供可抵扣的运输增值税专用发票(必须是一般纳税人，税率9%）', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '企业主体无未结重大诉讼，未被列为失信被执行人，无其他不良记录', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '非美的/安得黑名单企业/供应商，与安得无利益冲突', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '无偷税漏税行为（电子税务局查询无欠税证明）', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '与集团人员无亲属关系（提供集团亲属关系盖章表）', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '接受安得基地业务押金管理方案，流量置换方案', qualificationFlag: '', sm: '', resultFlag: '' },
]

const INIT_OT = [
    { pgwd: '运作经验：具备线路运营经验，有完备的运作流程及相关机制', pfbz: '1年-2年：4分；\n3年-5年：8分；\n6年以上：10分；', zf: '10', df: '', resultFlag: '' },
    { pgwd: '年营业规模', pfbz: '1000万及以下：4分；\n1000-3000万：6分；\n3000-5000万：10分；\n5001-1亿：6分；\n超过1亿：4分；', zf: '10', df: '', resultFlag: '' },
    { pgwd: '安得业务量与线路总货量对比', pfbz: '10%-20%：6分；\n20%以上-30%：10分；\n30%以上-50%：6分；', zf: '10', df: '', resultFlag: '' },
    { pgwd: '客户货物平均重泡比', pfbz: '1:3 ≤ 重泡比 ≤1:4：10分\n1:4 ＜ 重泡比 ≤1:5： 8分\n1:5 ＜ 重泡比 ≤1:7： 4分', zf: '10', df: '', resultFlag: '' },
    { pgwd: '专线档口距离发货处接货距离', pfbz: '1~30KM：5分\n30~50KM：3分\n50~70KM：1分\n≥70KM：0分', zf: '5', df: '', resultFlag: '' },
    { pgwd: '自有车辆或者签订合同的车辆不少于3台；（9.6M或以上大车，自有车辆营运证与公司名一致，合同车辆提供合同扫描件）+行驶证', pfbz: '1辆：1分；\n2辆：2分；\n3辆：3分\n以此类推，满分10分，超过10辆均为10分', zf: '10', df: '', resultFlag: '' },
    { pgwd: '直达城市个数（串点城市*0.75系数）', pfbz: '1-2条：10分；\n3-4条：15分；\n5条以上：20分；', zf: '20', df: '', resultFlag: '' },
    { pgwd: '日均发车趟次', pfbz: '1-2趟：6分；\n3-4趟：8分；\n5趟以上：10分；', zf: '10', df: '', resultFlag: '' },
    { pgwd: '落地配资源', pfbz: '自建配送网络：5分；\n部分自建配送网络：3分；\n落地卖货：0分；', zf: '5', df: '', resultFlag: '' },
    { pgwd: '合作意愿', pfbz: '主观判断', zf: '10', df: '', resultFlag: '' },
]

export default {
    components: { BaseInfo },
    mixins: [scoreMixin],
    data() {
        return {
            // SRM_YES,
            // currentId: null,
            // currentVersion: null,
            currentRow: null,
            visible: false,
            loading: false,
            confirmLoading: false,
            // pdfTransforming: false,
            qlfTableData: JSON.parse(JSON.stringify(INIT_QT)),
            operationTableData: JSON.parse(JSON.stringify(INIT_OT)),
        };
    },
    methods: {
        open(row) {
            this.currentRow = row
            this.setUploadQlfForm(row)
            this.visible = true
            this.loading = true
            onlineDetail({ supplierCode: row.qualificationTypeCode, id: row.id }).then(res => {
                if (res && +res.code === 0) {
                    this.setData(res.data, JSON.parse(res.data.onlineContent || null))
                }
            }).finally(() => { this.loading = false })
        },
        close() {
            this.visible = false
            this.$refs.biRef.reset()
            this.qlfTableData = JSON.parse(JSON.stringify(INIT_QT))
            this.operationTableData = JSON.parse(JSON.stringify(INIT_OT))
        },
        setData(baseInfo, data) {
            this.$refs.biRef.setBaseInfo(baseInfo)
            if (!data) {
                return false
            }
            this.$refs.biRef.setFormData(data.supplierInfo)
            this.qlfTableData[0].resultFlag = data.supplierQualification.resultFlag
            this.qlfTableData.forEach((item, index) => {
                item.qualificationFlag = data.supplierQualification['qualification' + (index + 1) + 'Flag']
            })
            this.operationTableData[0].resultFlag = data.operationalCapability.resultFlag
            this.operationTableData.forEach((item, index) => {
                item.df = data.operationalCapability['risk' + (index + 1) + 'Score']
            })
        },
        confirm() {
            const supplierInfo = this.$refs.biRef.getData()
            // 资质信息-是否符合-必填校验
            const qlfValid = this.qlfTableData.every(item => !!item.qualificationFlag)
            const scoreValid = this.scoreValidate()
            if (supplierInfo && qlfValid && scoreValid) {
                this.generateAndUploadPDF(this.currentRow.qualificationName + '.pdf', () => {
                    this.confirmLoading = true
                    onlineSave(this.getParams()).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('提交成功!')
                            this.$emit('submit', this.getParamsFromUpload())
                            this.close()
                        }
                    }).finally(() => { this.confirmLoading = false })
                })
            } else {
                this.$message({
                    type: 'warning',
                    message: '请输入必填信息，字长不能超过20位(通讯地址100位)，得分列请输入0或正整数!',
                    duration: 4000,
                })
            }
        },
        // 所有得分项格式校验
        scoreValidate() {
            const oError = this.operationTableData.some(item => this.scoreError(item.df, item.zf))
            return !oError
        },
        getParams() {
            const params = {
                type: TYPE,
                onlineContent: '',
                ...this.getParamsFromUpload()
            }
            const supplierInfo = this.$refs.biRef.getData()
            const supplierQualification = {
                resultFlag: this.qlfTableData[0].resultFlag,
            }
            this.qlfTableData.forEach((item, index) => {
                supplierQualification['qualification' + (index + 1) + 'Flag'] = item.qualificationFlag
            })
            const operationalCapability = {
                resultFlag: this.operationTableData[0].resultFlag,
            }
            this.operationTableData.forEach((item, index) => {
                operationalCapability['risk' + (index + 1) + 'Score'] = item.df
            })
            params.onlineContent = JSON.stringify({ supplierInfo, supplierQualification, operationalCapability })
            return params
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if ([0, 1, 4, 5].includes(columnIndex)) {
                if (rowIndex === 0) {
                    return [11, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        opArraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 4) {
                if (rowIndex === 0) {
                    return [10, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        isError(val) {
            return ['', null, undefined].includes(val)
        },
        scoreError(score, max) {
             // 非0或正整数 || 大于最大值
             return !/^\+?[0-9][0-9]*$/.test(score) || Number(score) > Number(max)
        },
    },
    watch: {
        qlfTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                val[0].resultFlag = val.some(item => !item.qualificationFlag || item.qualificationFlag === '不符合') ? '不通过' : '通过'
            },
            deep: true,
        },
        operationTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                const total = val.reduce((t,v) => {
                    t.df += Number(this.scoreError(v.df, v.zf) ? 0 : v.df)
                    t.zf += Number(v.zf)
                    return t
                }, {df: 0, zf: 0})
                val[0].resultFlag = total.df >= Decimal.mul(total.zf, 0.6).toNumber() ? '通过' : '不通过'
            },
            deep: true,
        },
    },
}
</script>
<style lang="less">
.key-data-trans-legal-dialog {
    .el-dialog {
        margin-bottom: 0;
    }

    .el-dialog__body {
        overflow-y: scroll;
        padding: 0;
        height: calc(94vh - 113px);
        box-sizing: border-box;
    }

    .content-wrap {
        padding: 16px;
    }

    .title-container {
        // margin-bottom: 5px;
        font-size: 16px;
        color: #000;

        // i {
        //     float: right;
        //     padding-right: 10px;
        //     font-size: 24px;
        //     cursor: pointer;
        // }
    }

    .title {
        display: inline-block;
        font-weight: bold;

        &::before {
            display: inline-block;
            // border-radius: 50%;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }

    .sub-title {
        padding: 5px 10px;
        font-size: 14px;
        color: #000;
        background-color: #f2f2f2;
    }

    .el-table {
        // border-right: 1px solid #ebeef5;

        .cell {
            white-space: normal;
        }

        .header-bg th {
            background: #f5f7fa;
        }
    }

    .margin-bottom-20 {
        margin-bottom: 20px;
    }

    .require-title {
        font-size: 16px;
        color: #000;
    }

    .el-dialog__footer {
        padding-top: 15px;
        padding-bottom: 15px;
        text-align: center;
        border-top: 1px solid #d7d7d7;

        .el-button + .el-button {
            margin-left: 30px;
        }
    }

    .required {
        color: #f96c5f;
    }

    .is-error input {
        border-color: #f96c5f;
    }
}
</style>